"use strict";
exports.__esModule = true;
exports.DiscoveryGridComponent = void 0;
var angular = require("angular");
var basic_chart_component_1 = require("../basic-component/basic-chart.component");
// function formatIssueData(item: any) {
//     const score = item.prevIG * item.prevIM;
//     return {
//         name: item.name,
//         prevIG: item.prevIG,
//         prevIM: item.prevIM,
//         prevScore: score,
//     };
// }
var DiscoveryGridComponent = /** @class */ (function () {
    function DiscoveryGridComponent($scope, $timeout) {
        var _this = this;
        this.changeLabelLength = function (change) {
            if (change === void 0) { change = 0; }
            var ctrl = _this;
            if (!ctrl.settings.charsInLabel) {
                ctrl.settings.charsInLabel = 0;
            }
            ctrl.settings.charsInLabel = parseInt(ctrl.settings.charsInLabel);
            ctrl.settings.charsInLabel += change;
            ctrl.drawAddDiscoveryGrid();
        };
        var ctrl = this;
        ctrl.$scope = $scope;
        ctrl.sortBy = 'desc';
        $scope.$on('command:DISCOVERY_GRID', function (event, args) {
            $scope.$emit('workbench:loading', { 'load': false });
            ctrl.settings = (0, basic_chart_component_1.loadSettings)(args.treeName, args.config.data.settings);
            ctrl.portfolioLevel = false;
            ctrl.initAddDiscoveryGrid(event, args);
            ctrl.$scope.$apply();
        });
        $scope.$on('command:ADD_DISCOVERY_GRID', function (event, args) {
            $scope.$emit('workbench:loading', { 'load': false });
            ctrl.settings = (0, basic_chart_component_1.loadSettings)(args.treeName, args.config.data.settings);
            ctrl.portfolioLevel = true;
            ctrl.initAddDiscoveryGrid(event, args);
            ctrl.$scope.$apply();
        });
    }
    DiscoveryGridComponent.prototype.getMenu = function () {
        var ctrl = this;
        return [
            {
                'name': 'Display',
                'items': [{
                        'name': ctrl.settings.showTable ? 'Hide Table' : 'Show Table',
                        'toggle': ctrl.settings.showTable ? 'Show Table' : 'Hide Table',
                        'callback': function () {
                            ctrl.settings.showTable = !ctrl.settings.showTable;
                        }
                    }]
            },
            {
                'name': 'Export',
                'items': [{
                        'name': 'Table',
                        'callback': function () {
                            ctrl.exportCsv();
                        }
                    }]
            }
        ];
    };
    DiscoveryGridComponent.prototype.exportCsv = function (csvFormat) {
        if (csvFormat === void 0) { csvFormat = ''; }
        var ctrl = this;
        var csv = 'Path, Project Name, Issue Name, Ignorance, Impact, Readiness\n';
        if (ctrl.portfolioLevel) {
            ctrl.tableData.forEach(function (row) {
                if (row.isMain) {
                    csv += row.mainPath + ',' + row.name + ',' + row.issueName + ',' + row.mainIgnorance + ',' + row.mainImpact + ',' + row.mainScore + '\n';
                }
                if (row.isSibling) {
                    csv += row.siblingPath + ',' + row.name + ',' + row.issueName + ',' + row.siblingIgnorance + ',' + row.siblingImpact + ',' + row.siblingScore + '\n';
                }
            });
        }
        else {
            ctrl.discoverGridSeries.forEach(function (row) {
                csv += row.name + ',' + row.data[0][1] + ',' + row.data[0][0] + ',' + row.score + '\n';
            });
        }
        var blob = new Blob([csv], { type: "text/plain;charset=utf-8" });
        var currentDate = (0, basic_chart_component_1.getDate)();
        var filename = 'Discover_Grid_For_' + ctrl.nodeName + "_" + currentDate + ".csv";
        saveAs(blob, filename);
    };
    DiscoveryGridComponent.prototype.getIssueNameFromPlotData = function (point) {
        var issueName = '';
        var pointDetails = point.series.userOptions;
        point.series.userOptions.data.forEach(function (p, idx) {
            if (p[0] == point.x && p[1] == point.y) {
                issueName = pointDetails.issueTitles[idx] ? pointDetails.issueTitles[idx] : (pointDetails.issueNames[idx].substring(0, 15));
            }
        });
        return issueName;
    };
    DiscoveryGridComponent.prototype.initAddDiscoveryGrid = function (event, args) {
        var ctrl = this;
        ctrl.title = "Discovery Grid";
        ctrl.nodeName = args.node.name;
        ctrl.node = args.node;
        ctrl.menu = ctrl.getMenu();
        ctrl.mainSeries = args.config.data.data.main;
        ctrl.siblingSeries = args.config.data.data.sibling;
        ctrl.discoverGridSeries = ctrl.mainSeries.concat(ctrl.siblingSeries);
        ctrl.makeTableData();
        ctrl.sortTable();
        ctrl.drawAddDiscoveryGrid();
    };
    DiscoveryGridComponent.prototype.drawAddDiscoveryGrid = function () {
        var ctrl = this;
        Highcharts.chart('discoveryGridContainer', {
            chart: {
                type: 'scatter',
                width: 600,
                height: 600
            },
            title: {
                text: 'Discovery Grid'
            },
            credits: {
                enabled: false
            },
            legend: {
                enabled: true
            },
            xAxis: {
                title: {
                    text: '<b>Impact</b><br><i>How much resolution of the issue drives upside or increases confidence in the business case</i>',
                    style: {
                        // fontWeight: 'bold',
                        fontSize: 16
                    }
                },
                tickPositions: [1, 2, 3, 4, 5, 6, 7, 8, 9],
                categories: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
                startOnTick: false,
                endOnTick: false,
                min: 1,
                max: 9,
                tickInterval: 1,
                gridLineWidth: 1,
                lineWidth: 1,
                labels: {
                    style: {
                        fontWeight: 'bold',
                        fontSize: 14
                    }
                }
            },
            yAxis: {
                title: {
                    text: '<b>Ignorance</b><br><i>Ability of core organization to deal with the issue</i>',
                    style: {
                        // fontWeight: 'bold',
                        fontSize: 16
                    }
                },
                tickPositions: [1, 2, 3, 4, 5, 6, 7, 8, 9],
                categories: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
                startOnTick: false,
                endOnTick: false,
                min: 1,
                max: 9,
                tickInterval: 1,
                gridLineWidth: 1,
                lineWidth: 1,
                labels: {
                    style: {
                        fontWeight: 'bold',
                        fontSize: 14
                    }
                }
            },
            plotOptions: {
                scatter: {
                    marker: {
                        radius: 5,
                        symbol: 'square'
                    },
                    dataLabels: {
                        enabled: ctrl.settings.showLabel,
                        style: {
                            fontWeight: 'thin'
                        },
                        formatter: function () {
                            var issueName = ctrl.getIssueNameFromPlotData(this.point);
                            var label = issueName + " (" + this.point.series.userOptions.name + ')';
                            return label.slice(0, ctrl.settings.charsInLabel);
                        }
                    }
                }
            },
            tooltip: {
                enabled: ctrl.settings.showTooltip,
                formatter: function () {
                    var issueName = ctrl.getIssueNameFromPlotData(this.point);
                    return "<b>" + issueName + "</b>" +
                        ("<i>(" + this.point.series.userOptions.name + ")</i><br />") +
                        ("Impact: " + this.point.x.toFixed(0) + "<br />") +
                        ("Ignorance: " + this.point.y.toFixed(0));
                }
            },
            series: ctrl.discoverGridSeries.length > 0 ? ctrl.discoverGridSeries : [{ data: [] }]
        }, function (chart) {
            // SPECIFY - upper left quadrant
            chart.renderer
                // .rect(box.x - 5, box.y - 5, box.width + 10, box.height + 10, 5)
                .rect(chart.plotLeft, chart.plotTop, (chart.plotWidth * 4) / 9, (chart.plotHeight * 5) / 9, 5)
                .attr({
                fill: "#ffffb3F0",
                stroke: "gray",
                "stroke-width": 0.5,
                zIndex: 0
            })
                .add();
            // SPECIFY - upper left quadrant label
            chart.renderer
                .text("Specify", chart.plotLeft + (chart.plotWidth * 4) / 9 / 2, chart.plotTop + (chart.plotHeight * 5) / 9 / 2)
                .attr({
                zIndex: 1,
                "text-anchor": "middle"
            })
                .css({
                fontSize: "30pt",
                color: "#AAAAAAC0"
            })
                .add();
            // DISCOVERY - upper right quadrant
            chart.renderer
                .rect(chart.plotLeft + (chart.plotWidth * 4) / 9, chart.plotTop, (chart.plotWidth * 5) / 9, (chart.plotHeight * 5) / 9, 5)
                .attr({
                fill: "#ffcce469",
                stroke: "gray",
                "stroke-width": 0.5,
                zIndex: 0
            })
                .add();
            // DISCOVERY - upper right quadrant label
            chart.renderer
                .text("Discovery", chart.plotLeft +
                (chart.plotWidth * 4) / 9 +
                (chart.plotWidth * 5) / 9 / 2, chart.plotTop + (chart.plotHeight * 5) / 9 / 2)
                .attr({
                zIndex: 1,
                "text-anchor": "middle"
            })
                .css({
                fontSize: "30pt",
                color: "#AAAAAAC0"
            })
                .add();
            // MANAGE - lower left quadrant
            chart.renderer
                .rect(chart.plotLeft, chart.plotTop + (chart.plotHeight * 5) / 9, (chart.plotWidth * 4) / 9, (chart.plotHeight * 4) / 9, 5)
                .attr({
                fill: "#b3ffe4A0",
                stroke: "gray",
                "stroke-width": 0.5,
                zIndex: 0
            })
                .add();
            // MANAGE - lower left quadrant label
            chart.renderer
                .text("Manage", chart.plotLeft + (chart.plotWidth * 4) / 9 / 2, chart.plotTop +
                (chart.plotHeight * 5) / 9 +
                (chart.plotHeight * 4) / 9 / 2)
                .attr({
                zIndex: 1,
                "text-anchor": "middle"
            })
                .css({
                fontSize: "30pt",
                color: "#AAAAAAC0"
            })
                .add();
            // NAVIGATE - lower right quadrant
            chart.renderer
                .rect(chart.plotLeft + (chart.plotWidth * 4) / 9, chart.plotTop + (chart.plotHeight * 5) / 9, (chart.plotWidth * 5) / 9, (chart.plotHeight * 4) / 9, 5)
                .attr({
                fill: "#a0c5f899",
                stroke: "gray",
                "stroke-width": 0.5,
                zIndex: 0
            })
                .add();
            // NAVIGATE - lower right quadrant label
            chart.renderer
                .text("Navigate", chart.plotLeft +
                (chart.plotWidth * 4) / 9 +
                (chart.plotWidth * 5) / 9 / 2, chart.plotTop +
                (chart.plotHeight * 5) / 9 +
                (chart.plotHeight * 4) / 9 / 2)
                .attr({
                zIndex: 1,
                "text-anchor": "middle"
            })
                .css({
                fontSize: "30pt",
                color: "#AAAAAAC0"
            })
                .add();
        });
        // ctrl.updateTickPositions(charts);
    };
    // Function to dynamically update tick positions
    DiscoveryGridComponent.prototype.updateTickPositions = function (chart) {
        var ctrl = this;
        if (ctrl.discoverGridSeries.length == 0) {
            chart.series = [{ data: [] }];
            var newTickPositions = [1, 2, 3, 4, 5, 6, 7, 8, 9]; // Define your new tick positions dynamically
            // Update xAxis with new tick positions
            chart.xAxis[0].tickPositions = chart.yAxis[0].tickPositions = newTickPositions;
            // startOnTick:false,
            // endOnTick:false,
        }
    };
    DiscoveryGridComponent.prototype.sortTable = function () {
        var ctrl = this;
        if (ctrl.sortBy == 'desc') {
            //ctrl.tableData = ctrl.tableData.sort((a, b) => b.siblingScore - a.siblingScore);
            ctrl.tableData = ctrl.tableData.sort(function (a, b) { return b.mainScore - a.mainScore; });
            ctrl.sortBy = 'asc';
        }
        else {
            //ctrl.tableData = ctrl.tableData.sort((a, b) => a.siblingScore - b.siblingScore);
            ctrl.tableData = ctrl.tableData.sort(function (a, b) { return a.mainScore - b.mainScore; });
            ctrl.sortBy = 'desc';
        }
    };
    DiscoveryGridComponent.prototype.makeTableData = function () {
        var ctrl = this;
        ctrl.tableData = [];
        angular.copy(ctrl.mainSeries).forEach(function (projData) {
            projData.tableData.forEach(function (d, idx) {
                ctrl.tableData.push({
                    name: projData.name,
                    issueName: projData.issueNames[idx],
                    mainScore: projData.scores[idx],
                    mainIgnorance: d[1],
                    mainImpact: d[0],
                    isMain: true,
                    isSibling: projData.isSibling,
                    mainPath: projData.path
                });
            });
        });
        angular.copy(ctrl.siblingSeries).forEach(function (siblingProjData) {
            if ('name' in siblingProjData) {
                siblingProjData.tableData.forEach(function (d, idx) {
                    var dataMatched = false;
                    ctrl.tableData.forEach(function (td) {
                        if (td.name == siblingProjData.name && td.issueName == siblingProjData.issueNames[idx]) {
                            dataMatched = true;
                            td['siblingScore'] = siblingProjData.scores[idx];
                            td['siblingIgnorance'] = d[1];
                            td['siblingImpact'] = d[0];
                            td['isSibling'] = siblingProjData.isSibling;
                            td['siblingPath'] = siblingProjData.path;
                        }
                    });
                    if (!dataMatched) {
                        ctrl.tableData.push({
                            name: siblingProjData.name,
                            issueName: siblingProjData.issueNames[idx],
                            siblingScore: siblingProjData.scores[idx],
                            siblingIgnorance: d[1],
                            siblingImpact: d[0],
                            isMain: false,
                            isSibling: siblingProjData.isSibling,
                            siblingPath: siblingProjData.path
                        });
                    }
                });
            }
        });
    };
    return DiscoveryGridComponent;
}());
exports.DiscoveryGridComponent = DiscoveryGridComponent;
angular.module('smartorg.r6.acts.discoveryGrid', []).component('discoveryGrid', {
    template: require('./discovery-grid.component.html'),
    controller: DiscoveryGridComponent,
    bindings: {
        smartorg: '=',
        menu: '='
    }
});
module.exports = 'smartorg.r6.acts.discoveryGrid';
//# sourceMappingURL=discovery-grid.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/discovery-grid/discovery-grid.component.js